// Categories - Simple array of strings
export const categories = [
    'Abstract',
    'Collage Art',
    'Figurative',
    'Historical',
    'Landscape',
    'Nude',
    'Portrait',
    'Religious',
    'Still Life',
    'Sri Lankan Souvenirs',
    'Home Decor',
    'Ornaments',
];

// Branches info
export const branches = [
  {
    id: 1,
    name: "Unawatuna",
    address: "Unawatuna, Sri Lanka",
    hours: "8:00 AM - 11:00 PM"
  },
  {
    id: 2,
    name: "Mirissa",
    address: "Mirissa, Sri Lanka",
    hours: "9:00 AM - 10:00 PM"
  },
  {
    id: 3,
    name: "Ahangama",
    address: "Ahangama, Sri Lanka",
    hours: "9:00 AM - 10:00 PM"
  }
];

// Artworks - Gallery Items
export const artworks = [
  // Paste this into export const artworks = [

  {
    id: 1,
    title: "Reverie in Cerulean",
    artist: "",
    category: "Nude",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-1.jpg",
    description: "An intimate portrait study rendered in warm ochres and cool blues, capturing a moment of quiet contemplation with masterful light and shadow.",
    tags: ["acrylic", "canvas", "figurative", "portrait"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 2,
    title: "Adornment",
    artist: "",
    category: "Nude",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-2.jpg",
    description: "A striking figure against an oceanic backdrop, embellished with traditional jewelry, blending cultural elegance with modern figurative expression.",
    tags: ["acrylic", "canvas", "portrait", "figurative"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 3,
    title: "Harvest's Promise",
    artist: "",
    category: "Still Life",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-3.jpg",
    description: "A delicate still life of mangosteen fruits with verdant foliage, rendered with subtle tonal shifts and careful attention to botanical form.",
    tags: ["acrylic", "canvas", "nature"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 4,
    title: "Geometry of Joy",
    artist: "",
    category: "Religious",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-4.jpg",
    description: "A vibrant abstract composition in hot pink and golden tones, celebrating movement and form through bold geometric shapes and dynamic balance.",
    tags: ["acrylic", "canvas", "sri lankan", "traditional", "cultural"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 5,
    title: "Festival Procession",
    artist: "",
    category: "landscape",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-6.jpg",
    description: "A luminous celebration of cultural pageantry featuring ornately decorated elephants beneath a golden sky, alive with warm yellows and deep reds.",
    tags: ["acrylic", "canvas", "traditional", "sri lankan", "cultural"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 6,
    title: "Rails Through Verdant Valleys",
    artist: "",
    category: "Landscape",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-7.jpg",
    description: "A picturesque landscape capturing a heritage steam train crossing a stone viaduct through lush countryside and rolling green hills.",
    tags: ["acrylic", "canvas", "architectural", "nature"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 7,
    title: "Noble Sentinel",
    artist: "",
    category: "Figurative",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-9.jpg",
    description: "A striking animal portrait of a boxer dog with alert ears and expressive features, rendered in warm browns and crisp white markings.",
    tags: ["acrylic", "canvas", "dog"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 8,
    title: "Water Lilies in Motion",
    artist: "",
    category: "Landscape",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-10.jpg",
    description: "An impressionistic study of luminous water lilies blooming among iridescent lily pads on weathered teal waters, capturing light and reflection.",
    tags: ["acrylic", "canvas", "floral", "sri lankan", "nature"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 9,
    title: "Coconut Against the Stillness",
    artist: "",
    category: "Landscape",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-12.jpg",
    description: "A minimalist ink study of silhouetted coconut trees creating elegant negative space against a serene, neutral sky—timeless and contemplative.",
    tags: ["acrylic", "canvas", "nature", "ocean", "coconut tree"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 10,
    title: "Tusked Majesty",
    artist: "",
    category: "Figurative",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-8.jpg",
    description: "A finely detailed wildlife portrait of an elephant in profile, showcasing intricate texturing and warm earthy tones against a serene blue backdrop.",
    tags: ["acrylic", "canvas", "elephant", "sri lankan", "nature", "wildlife"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 11,
    title: "Pastoral Reverie",
    artist: "",
    category: "Landscape",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-14.jpg",
    description: "A serene countryside landscape featuring a farmstead nestled among verdant fields, with grazing livestock and dramatic storm clouds gathering above, rendered in rich earth tones and greens.",
    tags: ["acrylic", "canvas", "dreamlike", "nature", "sri lankan"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 12,
    title: "Spectrum of Spirit",
    artist: "",
    category: "landscape",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-15.jpg",
    description: "An expressive dog portrait bursting with vibrant rainbow hues and dynamic brushwork, capturing personality and energy through contemporary color abstraction.",
    tags: ["acrylic", "canvas", "dog", "portrait", "animal"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 13,
    title: "Guardian in Emerald",
    artist: "",
    category: "Figurative",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-17.jpg",
    description: "A striking boxer dog portrait rendered against a luminous green background, showcasing fine facial detail and noble composure with warm tan and black markings.",
    tags: ["acrylic", "canvas", "dog", "animal", "portrait"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 14,
    title: "Gentle Contemplation",
    artist: "",
    category: "Figurative",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-20.jpg",
    description: "An intimate portrait study of a woman with silvery hair, rendered with soft skin tones and introspective gaze, balanced against a subtle, muted background.",
    tags: ["acrylic", "canvas", "figurative", "portrait"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 15,
    title: "Valor in Copper",
    artist: "",
    category: "Figurative",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-21.jpg",
    description: "A dignified boxer dog portrait set against a calming blue sky, with rich chestnut and white markings capturing alert watchfulness and gentle strength.",
    tags: ["acrylic", "canvas", "animal", "dog"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 16,
    title: "Fishermen at Twilight",
    artist: "",
    category: "Landscape",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-22.jpg",
    description: "A dramatic seascape depicting traditional fishermen with their iconic long-tail boats silhouetted against a fiery sunset of reds, oranges, and golds—capturing the essence of water culture.",
    tags: ["acrylic", "canvas", "dreamlike", "beach", "sri lankan", "sunset", "tropical"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 17,
    title: "Tropical Sanctuary",
    artist: "",
    category: "Landscape",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-23.jpg",
    description: "A serene tropical composition featuring graceful palm trees framed against an emerald horizon and turquoise waters, evoking peaceful island solitude.",
    tags: ["acrylic", "canvas", "coconut tree", "tropical", "beach"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 18,
    title: "Rainbow Vessels Collection",
    artist: "",
    category: "Home Decor",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/souvenir-3.jpg",
    description: "Handcrafted decorative gourds with vibrant acrylic finishes in red, orange, yellow, green, and blue—each adorned with traditional patterns and antique brass accents, perfect for home décor.",
    tags: ["cultural", "sri lankan", "traditional"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 19,
    title: "Shell Keepers—Diptych",
    artist: "",
    category: "Home Decor",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/souvenir-5.jpg",
    description: "A pair of naturally textured tortoise shell replicas with intricate segmentation, each crowned with a cheerful yellow sculptural element—a unique artisan decorative piece blending nature and craft.",
    tags: ["coconut shell", "animal"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 20,
    title: "Shell Sentinel Sculpture",
    artist: "",
    category: "Sri Lankan Souvenirs",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/souvenir-6.jpg",
    description: "A charming handcrafted tortoise shell sculpture featuring rich golden-brown patina with detailed relief carving and a whimsical yellow crown accent—an ideal decorative conversation piece.",
    tags: ["coconut shell", "animal"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },
  
  {
    id: 21,
    title: "The Crimson Path",
    artist: "",
    category: "Religious",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-24.jpg",
    description: "A solitary monk in vibrant robes walks toward enlightenment through a luminous forest corridor, surrounded by autumn foliage in rich golds and greens with a glowing yellow sky beyond.",
    tags: ["acrylic", "canvas", "sri lankan", "traditional"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 22,
    title: "Peacock Radiance",
    artist: "",
    category: "Portrait",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-25.jpg",
    description: "A majestic peacock displays its resplendent plumage in brilliant blues, reds, yellows, and oranges, with intricate eye-spotted feathers rendered in vibrant expressionistic style.",
    tags: ["acrylic", "canvas", "animal", "sri lankan", "nature", "portrait", "wildlife"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 23,
    title: "Harbor's Celebration",
    artist: "",
    category: "landscape",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-26.jpg",
    description: "A contemporary mixed-media composition featuring colorful sailboats with vibrant flags anchored in shallow waters under a serene blue sky—capturing maritime culture and leisure.",
    tags: ["acrylic", "canvas", "sri lankan", "tropical", "sunset", "ocean", "dreamlike", "cultural"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 24,
    title: "Water Lilies Reverie",
    artist: "",
    category: "Portrait",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-28.jpg",
    description: "An enchanting study of white water lilies blooming among iridescent green lily pads on dark mirrored waters, capturing the interplay of light and reflection in nature.",
    tags: ["acrylic", "canvas", "wildlife", "nature", "elephant", "sri lankan"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 25,
    title: "Emerald Guardian",
    artist: "",
    category: "Portrait",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-27.jpg",
    description: "A magnificent elephant emerges from lush green jungle foliage, with delicate ivory tusks and warm earthy tones, rendered with careful attention to texture and wildlife detail.",
    tags: ["acrylic", "canvas", "wildlife", "nature", "sri lankan"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 26,
    title: "Spotted Nobility",
    artist: "",
    category: "Portrait",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-29.jpg",
    description: "A striking leopard portrait rendered in golden yellows and warm tones with precise spotted patterning, gazing with penetrating eyes against a dark expressive background.",
    tags: ["acrylic", "canvas", "wildlife", "nature", "animal", "sri lankan"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 27,
    title: "Family Bonds in Eden",
    artist: "",
    category: "Portrait",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-30.jpg",
    description: "A tender scene of two adult elephants with a young calf walking together through a verdant jungle sanctuary, emphasizing connection and protection in nature.",
    tags: ["acrylic", "canvas", "wildlife", "sri lankan", "nature", "elephant"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 28,
    title: "Nostalgia Layered",
    artist: "",
    category: "Landscape",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-31.jpg",
    description: "conceptual mixed-media composition blending architectural heritage buildings with vibrant graffiti art and newspaper elements, reflecting urban transformation and cultural memory—featuring Sri Lankan landscape.",
    tags: ["acrylic", "canvas", "sunset", "sri lankan", "ocean", "beach"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 29,
    title: "Spirit of the Wild",
    artist: "",
    category: "Portrait",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-32.jpg",
    description: "A commanding primate portrait bursting with rainbow hues—whites, blues, oranges, and yellows—creating a powerful, expressive study of intelligence and wild beauty.",
    tags: ["acrylic", "animal", "canvas", "wildlife", "nature"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 30,
    title: "Stilt Fishermen at Sunset",
    artist: "",
    category: "landscape",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-33.jpg",
    description: "A dramatic seascape depicting traditional stilt fishermen in colorful garments balanced on wooden poles against a fiery golden sunset and crashing waves—iconic cultural imagery.",
    tags: ["acrylic", "canvas", "sunset", "ocean", "sri lankan", "traditional", "beach", "cultural", "tropical"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

    {
    id: 31,
    title: "Festival Splendor",
    artist: "",
    category: "Religious",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-34.jpg",
    description: "A vibrant celebration of decorated temple elephants adorned in brilliant reds, yellows, and golds with ornate ceremonial dress, attended by devotees in traditional white garments against a dark mystical backdrop.",
    tags: ["acrylic", "canvas", "animal", "cultural", "elephant", "sri lankan", "traditional"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 32,
    title: "Ride the Barrel",
    artist: "",
    category: "Portrait",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-35.jpg",
    description: "A dynamic action portrait of a surfer expertly navigating the perfect wave, captured in brilliant blues and whites with masterful movement and energy frozen in time.",
    tags: ["acrylic", "canvas", "beach", "fantasy", "ocean", "sri lankan", "sunset", "tropical", "portrait"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 33,
    title: "Meditation in Magenta",
    artist: "",
    category: "Religious",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-36.jpg",
    description: "An ethereal spiritual figure in vibrant pink and orange robes sits in lotus position with glowing orb above, rendered in contemplative minimalism against a dark serene background.",
    tags: ["acrylic", "canvas", "cultural", "portrait", "sri lankan", "traditional"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 34,
    title: "Nine Arch at Sunset",
    artist: "",
    category: "Landscape",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-37.jpg",
    description: "A striking landscape of a vintage red steam train crossing an elegant stone viaduct beneath a magnificent golden and orange sunset, with lush green forests framing the scene.",
    tags: ["acrylic", "canvas", "sri lankan", "sunset", "cultural", "architectural"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 35,
    title: "Reflective Beauty",
    artist: "",
    category: "Nude",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/artwork-38.jpg",
    description: "An intimate figurative study of a woman in contemplative repose, rendered with warm earthy tones and careful attention to form, exploring themes of vulnerability and introspection.",
    tags: ["acrylic", "canvas", "figurative", "portrait", "sri lankan"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  },

  {
    id: 36,
    title: "Wisdom Layered",
    artist: "",
    category: "Collage Art",
    price: "",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/collage-01.jpg",
    description: "A striking mixed-media collage featuring an owl emerging from layers of newspaper clippings and magazine cutouts in rich blues, reds, and earth tones—blending nature with urban narrative.",
    tags: ["canvas", "collage", "animal", "nature", "sri lankan", "wildlife", "paper"],
    branch: ["Unawatuna", "Mirissa", "Ahangama"]
  }

];

// Projects for OurWork page
export const projects = [
  {
    id: 1,
    title: "Luxury Villa",
    description: "Complete art curation for modern luxury villa with ocean view",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/project-1.jpg",
    project_type: "villa",
    location: "Unawatuna",
    images: [
      "https://sgkolinskyweb.blob.core.windows.net/$web/project-1.jpg",
      "https://sgkolinskyweb.blob.core.windows.net/$web/project1-intrior.jpg",
      "https://sgkolinskyweb.blob.core.windows.net/$web/project-1-interior2.jpg",
    ]
  },
 
  {
    id: 3,
    title: "Residential Apartment",
    description: "Modern apartment with contemporary art pieces",
    imageUrl: "https://sgkolinskyweb.blob.core.windows.net/$web/project-resident.jpg",
    project_type: "residential",
    location: "",
    images: [
      "https://sgkolinskyweb.blob.core.windows.net/$web/project-resident.jpg",
    ]
  }
];